import React from 'react';

function Header() {
  return (
    <nav className="bg-blur-10 fixed-top">
      <div className="container">
        <div className='row align-items-center'>
          <div className='col-md-6'>
            <img src='img/rmac.png' alt='rmac' height={30} />
          </div>
          <div className='col-md-6'>          
            <nav className="navbar navbar-expand-lg fs-5" id="navbar-main">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" href="#home">Home</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#about">About</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#experiences">Experiences</a>
                </li>
                {/*<li className="nav-item">
                  <a className="nav-link" href="#portfolio">Portfolio</a>
                </li>*/}
                <li className="nav-item">
                  <a className="nav-link" href="#contacts">Contacts</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;